import React, { useContext, Fragment, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import PersonIcon from '@material-ui/icons/Person';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import HomeLayout from '../Layouts/homeLayout';
import { PayloadContext } from '../../context';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as meActions from '../../store/actions/meActions';
import { getMyActiveLicenses } from '../../actions/license';
import LoadingView from '../Loader/LoadingView';
import './index.css';
import { saveSchedule } from '../../actions/schedule';
import { toast } from 'react-toastify';
import CreateSchedule from '../schedule/components/add';
// import HourglassEmptyIcon from '@material-ui/icons/HourglassEmpty';
import InventoryIcon from '@mui/icons-material/Inventory';
import ShoppingCartOutlinedIcon from '@material-ui/icons/ShoppingCartOutlined';
import VideoCallIcon from '@material-ui/icons/VideoCallOutlined';
import CalendarIcon from '@material-ui/icons/DateRange';
import ScheduleIcon from '@material-ui/icons/ScheduleOutlined';
import DocIcon from '@material-ui/icons/InfoOutlined';
import PlayVideoIcon from '@material-ui/icons/PlayCircleOutlineOutlined';
// import OpenUserManual from './components/openManual';
import { diffrenceInDays } from '../../utils';
import PeopleIcon from '@mui/icons-material/People';
import EyeIcon from '../../images/eye-icon.png';
import ProductModel from './components/ProductModel';
import { PORTAL } from '../../config';

const DashboardPage = (props) =>
{
	const history = useHistory();

	const [ loading, setLoading ] = useState(false);
	const [ openModal, setOpenModal ] = useState(false);
	const [ opensch, setOpenSch ] = useState(false);
	const [ planId, setPlanId ] = useState('');
	const [ openManual, setOpenManual ] = useState(false);
	const [ openMeetingManual, setOpenMeetingManual ] = useState(false);
	const { payload, getPayload } = useContext(PayloadContext);
	const [ type, setType ] = useState('');

	useEffect(() =>
	{
		let isMounted = true;

		// eslint-disable-next-line no-console
		// console.log('payload.plan', payload.plan);
		if (payload && payload.plan)
		{
			setLoading(true);
			getMyActiveLicenses('').then((res) =>
			{
				if (!isMounted) return;

				// eslint-disable-next-line no-console
				// console.log('res ==== ', res);
				setLoading(false);
				if (res && res.status)
				{
					props.setMyLicenses([ ...res.data.data ]);
				}
				else
				{
					props.setMyLicenses([]);
				}
			})
				.catch((err) =>
				{
					if (!isMounted) return;

					// eslint-disable-next-line no-console
					console.log('err ==== ', err);
					setLoading(false);
					props.setMyLicenses([]);
				});
		}

		return () =>
		{
			isMounted = false;
		};
	}, [ payload, getMyActiveLicenses ]);

	const handleActivate = () =>
	{
		history.push('/activation');
	};

	const handleStart = () =>
	{
		if (props.licenses && props.licenses?.length > 0)
		{
			if (props.licenses[0].type === 'eCard')
			{
				if (props.licenses[0].duration < 80*60)
				{
					history.push(`/meet/${props.licenses[0]._id}`);
				}
				else
				{
					toast.warning('Limit exceeded');
				}
			}
			else
			{
				history.push(`/meet/${props.licenses[0]._id}`);
			}
		}
		else
		{
			toast.warning('No active license found.');
		}
	};

	const handleLogout = () =>
	{
		localStorage.removeItem('userAuthToken');
		getPayload();
		history.push('/');
	};

	const handleContact = () =>
	{
		history.push('/address-book');
	};

	// const handleOrders = () =>
	// {
	// 	history.push('/packs');
	// 	// history.push('/e-cards');
	// 	// history.push('/e-card-sales');
	// };

	const handleViewSchedule = () =>
	{
		history.push('/schedule');
	};

	const handleWatchVideos = () =>
	{
		history.push('/watch-videos');
	};

	const handleSchedule = () =>
	{
		setOpenSch(true);
	};

	const handleSaveSchedule = (formData) =>
	{
		setLoading(true);
		saveSchedule(formData).then((res) =>
		{
			// eslint-disable-next-line no-console
			// console.log('res ==== ', res);
			if (res?.data?.status)
			{
				setOpenSch(false);
				toast.success('Created successfully');
				history.push('/schedule');
			}
			else
			{
				const msg = res?.data?.message ? res?.data?.message : 'Internal server error, Please try again';

				toast.error(msg);
			}
		})
			.catch((err) =>
			{
				// eslint-disable-next-line no-console
				console.log('err ==== ', err);
				toast.error('Internal server error, Please try again');
			});
	};

	const handleUserprofile = () =>
	{
		history.push('/user-profile');
	};

	const handleUsers = () =>
	{
		history.push('/users');
	};

	const leftTime = (lic, allowedHours) =>
	{
		// const allowedHours = userType === 'SalesAgent' ? 50 : 60;

		if (lic?.duration > 0)
		{
			const diff = allowedHours*60 - lic.duration;

			let str = `${Math.floor(diff/60)} Hours`;

			str += Math.floor(diff%60) > 0 ? ` ${Math.floor(diff%60)} Minutes` : '';

			return str;
		}
		else
		{
			return `${allowedHours} Hours`;
		}
	};

	let licenses;

	// eslint-disable-next-line no-console
	// console.log('payload ===== ', payload, props.licenses);
	if (props.licenses && props.licenses?.length > 0)
	{
		const _lic = props.licenses?.sort((a, b) => (a.expireDate - b.expireDate ? 1 : 0));

		licenses = _lic.find((item) => item.expireDate > new Date().valueOf());
	}

	const allInactive = payload?.licenses?.every((license) => license.activeCount === 0);

	const nameMapping = {
		PCR            : 'Personal Conference Room',
		BACR           : 'Basic Conference Room',
		BPCR           : 'Basic Pro Conference Room',
		ECR            : 'Enterprise Conference Room',
		BCR            : 'Business Conference Room',
		CCR            : 'Corporate Conference Room',
		'eCard_planC'  : 'KonX eCard',
		'eCard_planB'  : 'KonX eCard',
		'eCard_planA'  : 'KonX eCard',
		customerPlanA  : 'Personal Conference Room',
		customerPlanB  : 'Basic Conference Room',
		customerPlanC  : 'Basic Pro Conference Room',
		customerPlanD  : 'KonX eCard',
		EnterpriseRoom : 'Enterprise Conference Room',
		BusinessRoom   : 'Business Conference Room',
		CorporateRoom  : 'Corporate Conference Room'
	};

	const aggregatedLicenses = payload?.planMap?.reduce((acc, license) =>
	{
		const eCardOne = license.planId.length==24 && license.type== 'eCard' ? 'customerPlanD':'';
		const eCardTwo = license.planId=='planA' && license.type== 'eCard' ? 'customerPlanD':'';
		const eCardThree = license.planId=='planA' && license.type== 'eCard' ? 'customerPlanD':'';
		const eCardFour = license.planId=='planB' && license.type== 'eCard' ? 'customerPlanD':'';
		const eCardFive = license.planId=='planC' && license.type== 'eCard' ? 'customerPlanD':'';
		const name =nameMapping[eCardOne]|| nameMapping[eCardTwo]||nameMapping[eCardThree]||nameMapping[eCardFour]||nameMapping[eCardFive]|| nameMapping[license.type] || nameMapping[license.planId] || 'Unknown License';

		if (!acc[name])
		{
			acc[name] =
			{
				name,
				activeCount   : 0,
				inactiveCount : 0
			};
		}

		acc[name].activeCount += license.activeCount || 0;
		acc[name].inactiveCount += license.inactiveCount || 0;

		return acc;
	}, {});

	const aggregatedLicensesArray = Object.values(aggregatedLicenses);

	// eslint-disable-next-line no-console
	// console.log('aggregatedLicensesArray', aggregatedLicensesArray);

	return (
		<div className='flexCol alignCntr baseBg pdngLG dashboardCntnr'>
			<div className='flexCol alignCntr whiteTxt LinearGradientGreen brdrRadiusSM pdngXXS'>
				<h3 className='fontWeightNormal textCntr'>Welcome to your Account Center</h3>
			</div>
			{loading && <LoadingView />}
			<div className='flexCol alignCntr pdngSM'>
				<span>There are 2 ways to start a meeting:</span>
				<span>1) CLICK <b>Quick Start a Session</b> to start a meeting right
					now with your guests.</span>
				<span>2) CLICK <b>Schedule a Session</b> to schedule a
					meeting for future date(s).</span><br/>
				<span>To learn more about the other functionalities in your
					AccountCenter, check out the video below.</span>
				<span><b>Your Journey to LIVE Communications begins RIGHT HERE!!</b></span>
			</div>
			{/* <div className='flexAutoCol
			mrgnVSM pdngHLG resWidth35' onClick={handleActivate}>
				<img src='/images/activate_button.gif' alt='activateBtn' />
			</div> */}
			<div className='resRowCol'>
				<div className='flexAutoCol resWidth33 pdngSM'>
					<div className='flexCol alignCntr linearGradientBlue brdrRadiusSM whiteTxt pdngVSM'>
						<h3>User Dashboard</h3>
					</div>
					<div className='flexCol'>
						<ul className='overViewList mrgnTMD fullWidth'>
							{/* <li className='flexRow alignCntr pdngSM dashboardLi ptr'>
								<TvIcon/>&nbsp; Dashboard
							</li> */}
							<li className='flexRow alignCntr pdngSM dashboardLi ptr' onClick={handleUserprofile}>
								<PersonIcon />&nbsp; My Profile
							</li>
							<li className='flexRow alignCntr pdngSM dashboardLi ptr' onClick={handleContact}>
								<FormatListBulletedIcon />&nbsp; Address Book
							</li>
							{/* {payload && payload.userType !== 'SalesAgent' && <li className='flexRow alignCntr pdngSM dashboardLi ptr' onClick={handleActivate}>
								<HourglassEmptyIcon />&nbsp; Activate License
							</li>} */}
							<li className='flexRow alignCntr pdngSM dashboardLi ptr' onClick={handleActivate}>
								<InventoryIcon />&nbsp; Products
							</li>
							{payload?.userType === 'Admin' && <li className='flexRow alignCntr pdngSM dashboardLi ptr' onClick={handleUsers}>
								<PeopleIcon/>&nbsp; User Management
							</li>}
							{payload && payload.userType !== 'Admin' && <li className='flexRow alignCntr pdngSM dashboardLi ptr'>
								<a href={payload.userType !== 'Customer' ? 'https://powerof10.biz/back-office' : payload.userType !== 'Agent' ? 'https://konx.biz/order.php' : ''} target='_blank' rel='noreferrer'><ShoppingCartOutlinedIcon/>&nbsp; Order/Re-Order Products</a>
							</li>}
							<li className='flexRow alignCntr pdngSM dashboardLi ptr' onClick={handleLogout}>
								<ExitToAppIcon/>&nbsp; Logout
							</li>
						</ul>
					</div>
				</div>
				<div className='flexMinWidthCol resWidth33 pdngSM'>
					<div className='flexCol alignCntr linearGradientBlue brdrRadiusSM whiteTxt pdngVSM'>
						<h3>Account Details</h3>
					</div>
					<div className='resRowCol mrgnTMD'>
						<div className='flexCol'>
							<div className='flexMinWidthCol'>
								<div className={`flexRow justifyBtwn alignCntr brdrRadiusSM whiteTxt pdngSM ${PORTAL=='WORLD'?'linearAquaOrange':'linearGradientOrange'}`}>
									<span>Active License</span>
									<div>
										<span>Qty</span>
										<span className='ms-3'>Show</span>
									</div>
								</div>
								<div className='flexCol productListCntnr pdngSM whiteBg mrgnVXS brdrRadiusSM'>

									{/* {payload && payload.userType === 'TeamAgent' && payload.planMap && payload.planMap.length > 0 && (
										[ ...new Map(
											payload.planMap.map((item) => [ `${item.type}_${item.planId}`, item ])
										).values() ] // Ensure unique items based on type and planId
											.filter((license) =>
												license.activeCount > 0 &&
											(
												license.type === 'PCR' ||
												license.type === 'BACR' ||
												license.type === 'BPCR' ||
												(license.type === 'eCard' && license.planId === 'planC') ||
												(license.type === 'eCard' && license.planId === 'planB') ||
												license.planId === 'EnterpriseRoom' ||
												license.planId === 'BusinessRoom' ||
												license.planId === 'CorporateRoom'
											)
											).map((license) => license?.activeCount > 0 && (
												<div key={license.planId} className='flexRow justifyBtwn pdngXS'>
													<div className='d-flex justifyBtwn w-100 resAlignCntr'>
														<span>
															{license.type === 'PCR' && 'Personal Conference Room'}
															{license.type === 'BACR' && 'Basic Conference Room'}
															{license.type === 'BPCR' && 'Basic Pro Conference Room'}
															{license.type === 'eCard' && license.planId === 'planC' && 'KonX eCard'}
															{license.type === 'eCard' && license.planId === 'planB' && 'KonX eCard'}
															{license.planId === 'EnterpriseRoom' && 'Enterprise Conference Room'}
															{license.planId === 'BusinessRoom' && 'Business Conference Room'}
															{license.planId === 'CorporateRoom' && 'Corporate Conference Room'}
														</span>
														<div className='d-flex resAlignCntr'>
															<span>{license.activeCount || 0}</span>
															<img
																onClick={() =>
																{
																	setOpenModal(true);
																	setPlanId(license.planId);
																	setType(license.type);
																}}
																className='cursor-pointer ms-3'
																src={EyeIcon}
																alt='eye-icon'
																width={30}
															/>
														</div>
													</div>
												</div>
											))
									)} */}
									{/* {payload && payload.planMap && payload.planMap.length > 0 && (
										[ ...new Map(
											payload.planMap.map((item) => [ `${item.type}_${item.planId}`, item ])
										).values() ] // Create a map to ensure uniqueness based on type and planId
											.filter((license) =>
												license.activeCount > 0 &&
											(
												license.type === 'PCR' ||
												license.type === 'BACR' ||
												license.type === 'BPCR' ||
												license.type === 'BCR' ||
												license.type === 'CCR' ||
												license.type === 'ECR' ||
												license.type === 'eCard' ||
												(license.type === 'eCard' && license.planId === 'planC') ||
												(license.type === 'eCard' && license.planId === 'planB') ||
												license.planId === 'customerPlanA' ||
												license.planId === 'customerPlanB' ||
												license.planId === 'customerPlanC' ||
												license.planId === 'customerPlanD' ||
												license.planId === 'EnterpriseRoom' ||
												license.planId === 'BusinessRoom' ||
												license.planId === 'CorporateRoom'
											)
											).map((license) => (
												<div key={license.planId} className='flexRow justifyBtwn pdngXS'>
													<div className='d-flex justifyBtwn w-100 resAlignCntr'>
														<span>
															{license.type === 'PCR' && 'Personal Conference Room'}
															{license.type === 'BACR' && 'Basic Conference Room'}
															{license.type === 'BPCR' && 'Basic Pro Conference Room'}
															{license.type === 'eCard' && license.planId === 'planC' && 'KonX eCard'}
															{license.type === 'eCard' && license.planId === 'planB' && 'KonX eCard'}
															{license.planId === 'customerPlanA' && 'Personal Conference Room'}
															{license.planId === 'customerPlanB' && 'Basic Conference Room'}
															{license.planId === 'customerPlanC' && 'Basic Pro Conference Room'}
															{license.planId === 'customerPlanD' && 'KonX eCard'}
															{license.planId === 'EnterpriseRoom' && 'Enterprise Conference Room'}
															{license.planId === 'BusinessRoom' && 'Business Conference Room'}
															{license.planId === 'CorporateRoom' && 'Corporate Conference Room'}
															{license.type === 'ECR' && 'Enterprise Conference Room'}
															{license.type === 'BCR' && 'Business Conference Room'}
															{license.type === 'CCR' && 'Corporate Conference Room'}
															{license.type === 'eCard' && license.planId.length == 24 && 'KonX eCard'}
														</span>
														<div className='d-flex resAlignCntr'>
															<span>{license.activeCount || 0}</span>
															<img
																onClick={() =>
																{
																	setOpenModal(true);
																	setPlanId(license.planId);
																	setType(license.type);
																}}
																className='cursor-pointer ms-3'
																src={EyeIcon}
																alt='eye-icon'
																width={30}
															/>
														</div>
													</div>
												</div>
											))
									)} */}
									{aggregatedLicensesArray && aggregatedLicensesArray && aggregatedLicensesArray.length > 0 && (
										aggregatedLicensesArray.map((license) => license?.activeCount > 0 && (
											<div key={license?.name} className='flexRow justifyBtwn pdngXS'>
												<div className='d-flex justifyBtwn w-100 resAlignCntr'>
													<span>
														{license.name}
													</span>
													<div className='d-flex resAlignCntr'>
														<span>{license.activeCount || 0}</span>
														<img
															onClick={() =>
															{
																setOpenModal(true);
																setPlanId(license?.name);
															}}
															className='cursor-pointer ms-3'
															src={EyeIcon}
															alt='eye-icon'
															width={30}
														/>
													</div>
												</div>
											</div>
										))
									)}
									<ProductModel planId={planId} open={openModal} handleClose={() => setOpenModal(false)} type={type}/>
								</div>
							</div>
							{allInactive ?<div className={`cursor-pointer flexAutoCol justifyBtwn alignCntr linearGradientOrange brdrRadiusSM whiteTxt pdngSM ${PORTAL=='WORLD'?'linearAquaOrange':'linearGradientOrange'}`} onClick={() => history.push('/activation')}>
								<span className='textCntr'>You have no active license. Activate a license here</span>
							</div>:''}

						</div>
					</div>
				</div>
				<div className='flexAutoCol resWidth33 pdngSM'>
					<div className='flexRow justifyCntr alignCntr linearGradientBlue brdrRadiusSM whiteTxt pdngVSM'>
						<img src={PORTAL=='WORLD'?'/images/konx-prod.png':'/images/konx.png'} alt='' className='containedImg' />
						<h3>Conference</h3>
					</div>
					<div className='flexCol'>
						<ul className='overViewList mrgnTMD fullWidth'>
							{/* <li className='flexRow alignCntr pdngSM dashboardLi ptr'>
								<TvIcon/>&nbsp; Dashboard
							</li> */}
							<li className='flexRow alignCntr pdngSM dashboardLi ptr' onClick={handleStart}>
								<VideoCallIcon />&nbsp; Quick Start A Session
							</li>
							<li className='flexRow alignCntr pdngSM dashboardLi ptr' onClick={handleSchedule}>
								<ScheduleIcon />&nbsp; Schedule A Session
							</li>
							<li className='flexRow alignCntr pdngSM dashboardLi ptr' onClick={handleViewSchedule}>
								<CalendarIcon />&nbsp; View Schedules
							</li>
							<li className="flexRow alignCntr pdngSM dashboardLi ptr">
								<a
									href={PORTAL=='WORLD' ? "https://konx.world/getting-started/" : "https://konx.biz/getting-started/"}
									target="_blank"
									rel="noreferrer"
								>
									<div style={{display: 'flex', alignItems: 'center', gap: '4px'}}>
										<DocIcon />&nbsp;
										User Guide
									</div>
								</a>
							</li>
							<li className="flexRow alignCntr pdngSM dashboardLi ptr">
								<a
									href={PORTAL=='WORLD' ? "https://konx.world/why-konx/" : "https://konx.biz/why-konx/"}
									target="_blank"
									rel="noreferrer"
								>
									<div style={{display: 'flex', alignItems: 'center', gap: '4px'}}>
										<PlayVideoIcon />&nbsp;
										Why KonX?
									</div>
								</a>
							</li>
							{/* <li className='flexRow alignCntr pdngSM dashboardLi ptr'>
								<a href='https://konx.biz/docs/Starting-A-Meeting.pdf' target='_blank' rel='noreferrer'><DocIcon />&nbsp; User Manual</a>
							</li> */}
							{/* <li className='flexRow alignCntr pdngSM dashboardLi ptr' onClick={handleWatchVideos}>
								<PlayVideoIcon />&nbsp; Why KonX?
							</li> */}
						</ul>
					</div>
				</div>
			</div>
			<footer>
				<div className='ftr-row'>
					<div className='ftr-column'>
						<img src='https://konx.biz/images/appkonx-footer-img.jpg' className='ftr-col-content' />
					</div>
					<div className='ftr-column'>
						<video className='ftr-col-content' controls poster='https://konx.biz/images/how-to-start-a-mtg-tn.jpg'>
							<source src='https://konx.biz/video/how-to-use-konx.mp4' />
						</video>
					</div>
				</div>
			</footer>
			<div className='flexCol whiteTxt LinearGradientGreen brdrRadiusSM txtleft'>
				<h4 className='pdngXXS'> {PORTAL=='WORLD'?'www.konx.world':'www.konx.biz'}</h4>
			</div>
			{opensch &&
			<CreateSchedule
				open={opensch}
				handleClose={() => setOpenSch(false)}
				handleSave={handleSaveSchedule}
				data={null}
			/>}
			{openManual &&
				<OpenUserManual
					open={openManual}
					handleClose={() => setOpenManual(false)}
					title='User Manual'
					src='/Konx-UserManual.pdf'
				/>
			}
			{openMeetingManual &&
				<OpenUserManual
					open={openMeetingManual}
					handleClose={() => setOpenMeetingManual(false)}
					title='Start a Meeting Manual'
					src='https://konx.biz/docs/Konx-UserManual.pdf'
				/>
			}
		</div>
	);
};

// export default HomeLayout(DashboardPage);

DashboardPage.propTypes =
{
	licenses      : PropTypes.array,
	setMyLicenses : PropTypes.func.isRequired
};

const mapStateToProps = (state) =>
{
	return {
		licenses : state.me.licenses
	};
};

const mapDispatchToProps = (dispatch) =>
{
	return {
		setMyLicenses : (data) =>
		{
			dispatch(meActions.setMyLicenses(data));
		}
	};
};

export default HomeLayout(connect(
	mapStateToProps,
	mapDispatchToProps,
	null,
	{
		areStatesEqual : (next, prev) =>
		{
			return (
				prev.me.licenses === next.me.licenses
			);
		}
	}
)(DashboardPage));